<template>
  <v-card color="#02083C" flat tile>
    <v-app-bar flat color="#02083C" height="90px">
      <v-toolbar-title>
        <img src="@/assets/Capita_Logo.jpg" alt="GeoAd" class="logo" />
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <router-link to="/">Home</router-link>
      <router-link to="/docs">Documentation</router-link>
      <router-link to="#" @click.native="external">API Dashboard</router-link>
      <router-link to="/media">Media</router-link>
      <router-link to="/terms">Terms</router-link>
    </v-app-bar>
  </v-card>
</template>
<script>
export default {
  name: "Navigation",
  methods:{
    external(){
      window.open('https://apps.powerapps.com/play/ab4e739b-c6e3-4c16-837e-2c546f140772?tenantId=1edaad83-b2ef-483d-81f1-2c48682f40ec&source=portal&screenColor=rgba(0%2C%20176%2C%20240%2C%201)',"_blank")
    }
  }
};
</script>
<style scoped>
/* Style the header links */
a {
  float: left;
  color: white !important;
  text-align: center;
  padding: 12px;
  text-decoration: none;
  font-size: 18px;
  line-height: 25px;
}

/* Style the logo link (notice that we set the same value of line-height and font-size to prevent the header to increase when the font gets bigger */
.logo {
  font-size: 25px;
  font-weight: bold;
  height: 70px;
}

/* Change the background color on mouse-over */
a:hover {
  background-color: cyan;
  color: black !important;
  border-radius: 5px;
}
</style>
